import { render, staticRenderFns } from "./WhActivityIndex.vue?vue&type=template&id=5d2d32c4&scoped=true&"
import script from "./WhActivityIndex.vue?vue&type=script&lang=js&"
export * from "./WhActivityIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2d32c4",
  null
  
)

export default component.exports